import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserRole } from '../../model/Types';
import { currentUser, isAdmin, isLoggedIn } from '../../store/UserStore';
import { buildLocalizedPath } from '../../config/languages';
import { useCurrentLocale } from '../../hooks/useCurrentLocale';

interface ProtectedRouteProps {
    allowedRoles: UserRole[];
    children: React.ReactNode;
    isAdminOnly?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    allowedRoles,
    children,
    isAdminOnly,
}) => {
    const lang = useCurrentLocale();
    if (isAdminOnly && !isAdmin.value) {
        return <Navigate to={buildLocalizedPath('/forbidden', lang)} />;
    }
    if (
        !isLoggedIn.value ||
        (currentUser.value && !allowedRoles.includes(currentUser.value.role))
    ) {
        return <Navigate to={buildLocalizedPath('/unauthorized', lang)} />;
    }
    return <>{children}</>;
};
